import { tags } from './tags';

function endpoints(builder) {
  return {
    getProductCategories: builder.query({
      query: () => 'actions/frontend/catalog/get-product-categories',
      providesTags: tags,
    }),
    getCatalogTranslates: builder.query({
      query: () => 'actions/frontend/catalog/get-translates',
      providesTags: tags,
    }),
  };
}

export { endpoints };
